import React from 'react';
import { useLang } from '../../i18n/LanguageContext';

export default function GameProgress({
  current = 0,
  total = 24,
  label = 'Pièces collectées',
  // Texte de la ligne du bas. Par défaut le décompte de pièces du puzzle, qui
  // n'a de sens que sur une page de jeu : dans le tunnel de commande on y
  // passe un décompte d'étapes.
  messageRestant = null,
}) {
  // Ces deux phrases étaient écrites en dur : un acheteur néerlandais les
  // lisait en français au beau milieu du tunnel de commande, juste avant de
  // payer. Le `label`, lui, est déjà traduit par l'appelant.
  const { t } = useLang();
  const percentage = total > 0 ? Math.round((current / total) * 100) : 0;

  return (
    <div className="bg-gradient-to-br from-white/70 to-[#F7F4EC]/90 border-[3px] border-[#4AA294] rounded-lg p-6 backdrop-blur-[10px] shadow-md">
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <span className="text-[13px] font-bold uppercase tracking-wide text-[#2F7E72] font-['Fredoka',_'Poppins',_sans-serif]">
          {label}
        </span>
        <span className="text-base font-bold text-[#17453E] font-['Poppins',_sans-serif] bg-[#4AA294]/20 px-3.5 py-1.5 rounded-2xl border-2 border-[#4AA294]">
          {current}/{total}
        </span>
      </div>

      {/* Progress Bar Container */}
      <div className="flex gap-3 items-center mb-3">
        <div className="flex-1 h-7 bg-white border-2 border-[#4AA294] rounded-sm overflow-hidden relative shadow-[inset_0_2px_4px_rgba(93,78,55,0.1)]">
          <div
            className="h-full bg-gradient-to-r from-[#A8D5BA] to-[#4AA294] transition-[width] duration-500 ease-[cubic-bezier(0.25,0.46,0.45,0.94)] relative overflow-hidden"
            style={{ width: `${percentage}%` }}
          >
            <span className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-white/30 to-transparent animate-[shimmer-gentle_2s_infinite]"></span>
          </div>
        </div>
        <span className="min-w-[50px] text-right font-bold text-[#2F7E72] text-sm font-['Poppins',_sans-serif]">
          {percentage}%
        </span>
      </div>

      {/* Milestone */}
      <div className="text-center text-[13px] font-semibold h-5 flex items-center justify-center">
        {messageRestant ? (
          <span className="text-[#2F7E72] tracking-wide">{messageRestant}</span>
        ) : percentage === 100 ? (
          <span className="text-[#4AA294] animate-[pulse-soft_1s_infinite] text-sm font-bold">
            {t('progression.complete')}
          </span>
        ) : (
          <span className="text-[#2F7E72] tracking-wide">
            {t('progression.restant', { n: total - current })}
          </span>
        )}
      </div>

      {/* Keyframes for animations */}
      <style>{`
        @keyframes shimmer-gentle {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(100%);
          }
        }
        
        @keyframes pulse-soft {
          0%, 100% {
            opacity: 1;
            text-shadow: 0 0 8px rgba(212, 165, 116, 0.3);
          }
          50% {
            opacity: 0.85;
            text-shadow: 0 0 15px rgba(212, 165, 116, 0.6);
          }
        }
      `}</style>
    </div>
  );
}
